export interface GlobalConfig {
  title: string;
  cards: PageCard[];
  pages: Page[];
}

export interface PageCard {
  title: string;
  url: string;
  icon: string;
  buttonName: string;
}

export interface Page {
  id: number;
  parentId: number | null,
  type: PageTypes;
  childrenLinks: ChildLink[];
  title: string;
  description?: string;
  filesToDownload?: FileToDownload[];
  pdfUrl?: string;
}

export interface FileToDownload {
  name?: string;
  downloadButtonName: string;
  url: string;
}

export enum PageTypes {
  SECTION = 'sections',
}

export interface ChildLink {
  id: number;
  url: string;
  parentId: number | null;
  childrenLinks: ChildLink[];
  name: string;
}
